import React, {Component} from 'react';
import './CalloutAside.css';

const CalloutAside = ({primary, primaryOnRight = false, aside}) => {
	const prim = <div class="CalloutAside-primary">{primary}</div>;
	return (
		<section className="CalloutAside">
			{primaryOnRight ? null : prim}
			<aside>{aside}</aside>
			{primaryOnRight ? prim : null}
		</section>
	);
};

export default CalloutAside;



// WEBPACK FOOTER //
// ./src/widgets/CalloutAside.js